<template>
  <div>
    <div class="vx-row flex flex-col">
      <div class="vx-col w-full">
        <vs-card>
          <div slot="header">
            <h3>Edit Cluster Layanan</h3>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <flat-pickr style="width:100%" :config="configdateTimePicker" v-model="startTime" placeholder="Waktu Mulai" />
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <flat-pickr style="width:100%" :config="configdateTimePicker" v-model="endTime" placeholder="Waktu Selesai" />
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <vs-input style="width:100%" type="number" placeholder="Kapasitas" v-model="capacity"/>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-row w-full">
              <div class="flex flex-row">
                <vs-button
                  @click="updateData"
                  class="ml-8 w-1/2"
                  color="primary"
                  icon-pack="feather"
                  icon="icon-send"
                  type="filled"
                >Simpan</vs-button>
                <vs-button
                  @click="$router.push({name: 'services-detail', params : {id : $route.params.id}})"
                  class="ml-3 w-1/2"
                  color="primary"
                  icon-pack="feather"
                  icon="icon-arrow-left"
                  type="border"
                >Kembali</vs-button>
              </div>
            </div>
          </div>
        </vs-card>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
  data() {
    return {
      startTime: null,
      endTime:null,
      capacity: '',
      cluster_id : this.$route.params.cluster_id,
      configdateTimePicker: {
        enableTime: true,
        noCalendar: true,
        dateFormat: 'H:i'
      }
    };
  },
  mounted (){
    this.getClusterDetail();
  },
  methods: {
    getClusterDetail() {
      this.$http
      .get(`/app/secure/service/getClusterDetail/${this.cluster_id}`)
      .then(r => {
        this.startTime = r.data.data.cluster.start_time;
        this.endTime = r.data.data.cluster.end_time;
        this.capacity = r.data.data.cluster.capacity;
      })
      .finally(() => {
        this.$vs.loading.close();
      });
    },
    updateData() {
      this.$vs.loading();
      this.$http
        .post(`/app/secure/service/updateCluster`, {
          start_time : this.startTime,
          end_time : this.endTime,
          capacity : this.capacity,
          cluster_id : this.$route.params.cluster_id,
        })
        .then(() => {
          this.$vs.notify({
            title: "Sukses",
            text: "Berhasil update cluster .",
            color: "success",
            position: "top-right"
          });
          this.$router.push({name: 'services-detail', params : {id : this.$route.params.id}})
        })
        .catch(e => {
          this.parseError(e);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
  },
  components: {
    "v-select": vSelect,
    flatPickr
  }
};
</script>